import { render, staticRenderFns } from "./UploadArquivoDialog.vue?vue&type=template&id=1bcb7ff5&"
import script from "./UploadArquivoDialog.vue?vue&type=script&lang=js&"
export * from "./UploadArquivoDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadArquivoDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadArquivoDialog.vue"
export default component.exports